import React from 'react';
import PropTypes from 'prop-types';
import CommonLink from './CommonLink';
import { styled } from '@mui/material/styles';

const StyledDiv = styled('div')(({ theme, smallPadding, elevatedColor }) => ({
  position: 'relative',
  padding: smallPadding ? theme.spacing(1) : theme.spacing(3),
  borderRadius: theme.spacing(1),
  border: '1px solid #006AA7',
  color: theme.palette.common.black,
  backgroundColor: theme.palette.common.white,
}));

const CommonPaper = ({ className, bounced, elevated, elevatedColor, link, onClick, smallPadding, ...rest }) => {
  const hasAction = Boolean(link || onClick);
  const Wrapper = link ? CommonLink : 'div';
  const wrapperProps = link ? { to: link } : { onClick: onClick };

  return (
    <Wrapper
      {...wrapperProps}
      className={className}>
      <StyledDiv
        smallPadding={smallPadding}
        elevatedColor={elevatedColor}
        className={className}
        {...rest}
      />
    </Wrapper>
  );
};

CommonPaper.propTypes = {
  className: PropTypes.string,
  bounced: PropTypes.bool,
  elevated: PropTypes.bool,
  elevatedColor: PropTypes.oneOf(['default', 'primary', 'secondary']),
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
};

CommonPaper.defaultProps = {
  elevated: true,
  elevatedColor: 'default',
};

export default CommonPaper;
